import React from 'react';
import { NextPage } from 'next';
import { FeaturesPageTop } from './FeaturesPageTop';
import { Footer } from '../../../../layouts/Footer';
import { FeaturesOverall } from './FeaturesOverall';
import { FeaturesCustomize } from './FeaturesCustomize';
import { FeaturesUseIt } from './FeaturesUseIt';
import { FeaturesAnalyze } from './FeaturesAnalyze';
import { FeaturesEmbed } from './FeaturesEmbed';
import { SmartlinksPageExplore } from '../SmartlinksPageExplore';
import { IndexTalkingAboutUs } from '../../index/IndexTalkingAboutUs';
import { BigCTA } from '../BigCTA';
import { FeaturesNotAll } from './FeaturesNotAll';

/* eslint-disable react/no-danger */
export const FeaturesPage: NextPage = React.memo(() => {
  return (
    <>
      <FeaturesPageTop />
      <FeaturesOverall />
      <FeaturesCustomize />
      <FeaturesUseIt />
      <FeaturesAnalyze />
      <FeaturesEmbed />
      <SmartlinksPageExplore />
      <FeaturesNotAll />
      <div className="smartlink-bg-gradient">
        <IndexTalkingAboutUs />

        <BigCTA source="Features Page" />
      </div>
      <Footer />
    </>
  );
});
